<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item" v-for="(item, index) in basicInfoList" :key="index">
            <span class="basic_title">{{ item.name }}</span>
            <span class="basic_txt">{{ detailsData[item.paramsKey] }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1003718') }}</span>
            <Select v-model="currencyValue" transfer filterable style="width: 150px;" @on-change="changeCurrency" :disabled="detailsData.status !== 1">
              <Option v-for="(item, index) in currencyList" :key="index" :value="item.value">{{ item.label }}</Option>
            </Select>
          </Col>
        </Row>
      </Card>
    </div>
    <!--账单明细-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center">
              <h2 class="title_box mr20">{{ $t('key1003610') }}</h2>
              <span class="font-size-13">{{ $t('key1003717') + unreconciledOrderQuantity }}</span>
            </div>
            <CheckboxGroup v-model="pageParams.types" class="flex align-items-center" @on-change="checkChange">
              <Checkbox :label="1" class="mr30">{{ $t('key1003719') }}</Checkbox>
              <Checkbox :label="2">{{ $t('key1003720') }}</Checkbox>
            </CheckboxGroup>
          </div>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="500"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="billDetailsData">
          </Table>
          <div class="flex align-items-center justify-content-between font-size-12">
            <p class="flex align-items-center">
              <span>{{ $t('key1003721') }}</span>
              <span :class="payoffAmount < 0 ? 'crimsonRedColor' : ''">{{ payoffAmountTotal }}</span>
            </p>
            <Page
              :transfer="true"
              v-if="!tableLoading"
              :total="total"
              @on-change="changePage"
              show-total
              :page-size="pageParams.pageSize"
              show-elevator
              :current="pageParams.pageNum"
              show-sizer
              @on-page-size-change="changePageSize"
              placement="top"
              :page-size-opts="pageArray">
            </Page>
          </div>
        </div>
      </Card>
    </div>
    <!--操作按钮-->
    <div class="options_content">
      <Button class="mr15" type="primary" v-if="detailsData.status === 1 && getPermission('ymsBill_confirmSettlement')"
        @click="confirmSettlementBtn">{{ $t('key1002019') }}</Button>
    </div>
    <!--修改、添加备注弹窗-->
    <Modal v-model="modifyInfoModal" :title="modifyInfoTitle" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="modifyInfoChange">
      <Form ref="modifyInfoForm" :model="modifyInfoForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
        <Row style="width: 90%;">
          <!--修改-->
          <template v-if="modifyInfoType === 'update'">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003688')" prop="logisticsCost">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.logisticsCost">
                </InputNumber>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003715')" prop="otherCost">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.otherCost">
                </InputNumber>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003716')" prop="logisticsWeight">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.logisticsWeight">
                </InputNumber>
              </FormItem>
            </Col>
          </template>
          <!--添加备注-->
          <template v-else>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001495')" prop="remark" :label-width="80">
                <Input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  v-model.trim="modifyInfoForm.remark">
                </Input>
              </Form-item>
            </Col>
          </template>
        </Row>
      </Form>
      <template #footer>
        <Button @click="modifyInfoModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="modifyInfoBtn">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {formatterNumber, getAllUsersInfo, getCurrencyData, getUserNameByUserId, isValueEmpty} from "@/utils/common";

export default {
  name: "logisticsBillDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      ItemCol: 6,
      pageParams: {
        types: [],
        ymsBillId: null,
        pageNum: 1,
        pageSize: 15
      },
      basicInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003685'), paramsKey: 'billNo'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001579'), paramsKey: 'carrierName'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003593'), paramsKey: 'billTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003686'), paramsKey: 'updatedTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003687'), paramsKey: 'amount'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003688'), paramsKey: 'logisticsCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003689'), paramsKey: 'otherCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003690'), paramsKey: 'totalCost'}
      ], // 基本信息的基础数据
      detailsData: {},
      billDetailsColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003691'),
          key: 'documentCode',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003173'),
          key: 'businessMerchantIds',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let businessMerchantIds = params.row.businessMerchantIds || [];
            if (businessMerchantIds.length > 0) {
              return h('span', businessMerchantIds.join('、'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003692'),
          key: 'status',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let text = '-';
            let status = params.row.status;
            if (v.billType === '6') {
              text = status === 7 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003693') : status === 8 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813') : '-';
            } else {
              text = status === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003694') : status === 4 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003695') : status === 99 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003696') : '-';
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003697'),
          key: 'productGoodsWeight',
          minWidth: 170,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003699'),
          key: 'logisticsWeight',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003700'),
          key: 'amount',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.amount);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003701'),
          key: 'logisticsCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = '-';
            let logisticsCost = params.row.logisticsCost;
            let currency = params.row.logisticsProviderCurrency || v.currencyState;
            if (isValueEmpty(logisticsCost)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003702');
            } else {
              text = v.formatCurrency(logisticsCost) + ' ' + currency;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003703'),
          key: 'otherCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = '-';
            let otherCost = params.row.otherCost;
            let currency = params.row.logisticsProviderCurrency || v.currencyState;
            if (isValueEmpty(otherCost)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003702');
            } else {
              text = v.formatCurrency(otherCost) + ' ' + currency;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003704'),
          key: 'totalCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = '-';
            let totalCost = params.row.totalCost;
            let currency = params.row.logisticsProviderCurrency || v.currencyState;
            if (isValueEmpty(totalCost)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003702');
            } else {
              text = v.formatCurrency(totalCost) + ' ' + currency;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003705'), // crimsonRedColor
          key: 'profitAndLoss',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let profitAndLoss = params.row.profitAndLoss;
            let currency = params.row.currency || v.currencyState;
            let text = '';
            if (isValueEmpty(profitAndLoss)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003702');
            } else {
              text = (profitAndLoss > 0 ? '+' + v.formatCurrency(profitAndLoss) : v.formatCurrency(profitAndLoss)) + ' ' + currency;
            }
            return h('span', {class: profitAndLoss < 0 ? 'crimsonRedColor' : ''}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remark',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remark, 150, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003706'),
          key: 'despatchTime',
          minWidth: 170,
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.despatchTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003707'),
          key: 'source',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let text = '-';
            let source = params.row.source;
            let updatedBy = getUserNameByUserId(params.row.updatedBy, v.userInfoList);
            switch (source) {
              case 1:
                text = updatedBy + '-' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003708');
                break;
              case 2:
                text = updatedBy + '-' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002016');
                break;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 150,
          fixed: 'right',
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003503'),
                    show: v.getPermission('ymsBillPackageDetail_updateLogisticsYmsBillPackageDetail'),
                    clickFn: () => {
                      v.initModifyInfoData('update', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002015'),
                    show: v.getPermission('ymsBillPackageDetail_insertRemarks'),
                    clickFn: () => {
                      v.initModifyInfoData('addRemarks', params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      billDetailsData: [],
      total: 0,
      modifyInfoModal: false,
      modifyInfoTitle: '',
      modifyInfoForm: {
        remark: '', // 备注
        logisticsCost: null, // 应付物流费
        otherCost: null, // 应付其他费用
        logisticsWeight: null, // 物流实重
      },
      ruleValidate: {
        logisticsCost: [
          {required: true, type: 'number', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003709'), trigger: 'change'}
        ],
        remark: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003710'), trigger: 'blur'}
        ],
      },
      modifyInfoType: 'update',
      currencyValue: null,
      ymsBillId: null,
      modifyInfo: {},
      unreconciledOrderQuantity: 0,
      payoffAmount: 0,
      billType: '6',
      currencyList: [],
      userInfoList: {}
    };
  },
  computed: {
    // 处理盈亏数据
    payoffAmountTotal() {
      let payoffAmount = (this.payoffAmount > 0 ? ('+' + this.formatCurrency(this.payoffAmount)) :
        this.formatCurrency(this.payoffAmount)) + ' ' + this.currencyState;
      let txt = payoffAmount;
      return txt;
    },
    // 处理列表字段
    tableColumns() {
      let columns = [];
      if (this.detailsData.status === 2) {
        columns = this.billDetailsColumns.filter((item) => {
          return !['options'].includes(item.key);
        });
      } else {
        columns = this.billDetailsColumns;
      }
      return columns;
    }
  },
  created() {
    this.ymsBillId = this.$route.query.ymsBillId;
    this.billType = this.$route.query.billType;
    this.initLogisticsBillDetails();
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initLogisticsBillDetails() {
      (async () => {
        await getCurrencyData().then((data) => {
          this.currencyList = data;
        });
        await getAllUsersInfo().then(data => {
          this.userInfoList = data;
        });
        await this.getLogisticsBillDetailsData();
        await this.getPhaseData();
        await this.getLogisticsBillDetailsList();
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/logisticsBill');
    },
    // 获取物流账单详情数据
    getLogisticsBillDetailsData() {
      let v = this;
      v.detailsData = {};
      v.axios.get(api.get_ymsBill_detailLogisticsBill + v.ymsBillId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.currencyValue = data.logisticsProviderCurrency ? JSON.parse(JSON.stringify(data.logisticsProviderCurrency)) : v.currencyState;
            let costKeyList = ['amount', 'logisticsCost', 'otherCost', 'totalCost'];
            costKeyList.map((key) => {
              let currency = '';
              if (key === 'amount') {
                currency = data.currency || v.currencyState;
              } else {
                currency = data.logisticsProviderCurrency || v.currencyState;
              }
              data[key] = v.formatCurrency(data[key]) + ' ' + currency;
            });

            data['updatedTime'] = v.$uDate.dealTime(data.updatedTime, 'fulltime');
            if (data.billMonth) {
              let time = data.billMonth.split('-');
              data.billTime = `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
            }
            v.detailsData = data;
          }
        }
      });
    },
    // 获取物流账单明细列表
    getLogisticsBillDetailsList() {
      let v = this;
      v.optionBtnWidth = [];
      v.billDetailsData = [];
      v.total = 0;
      v.tableLoading = true;
      let query = Object.assign({}, v.pageParams);
      query.ymsBillId = v.ymsBillId;
      v.axios.post(api.post_ymsBillPackageDetail_queryLogisticsBillPackageDetail, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.billDetailsData = data.list || [];
            v.total = data.total;
          }
        }
      });
    },
    // 确认结算
    confirmSettlementBtn() {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003711'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003712'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002019'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsBill_confirmSettlement + v.ymsBillId, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003713'));
              v.initLogisticsBillDetails();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 初始化弹窗
    initModifyInfoData(type, data) {
      let obj = {
        update: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003503'),
        addRemarks: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002015')
      };
      this.modifyInfoTitle = obj[type];
      this.modifyInfoType = type;
      this.modifyInfo = data;
      if (data) {
        for (let key in this.modifyInfoForm) {
          this.modifyInfoForm[key] = data[key];
        }
      }
      this.modifyInfoModal = true;
    },
    // 保存按钮
    modifyInfoBtn() {
      let v = this;
      let url = '';
      let text = '';
      let query = {};
      if (v.modifyInfoType === 'update') {
        url = api.post_ymsBillPackageDetail_updateLogisticsYmsBillPackageDetail;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161');
        query = {
          logisticsCost: v.modifyInfoForm.logisticsCost, // 应付物流费
          otherCost: v.modifyInfoForm.otherCost, // 应付其他费用
          logisticsWeight: v.modifyInfoForm.logisticsWeight, // 物流实重
          ymsBillId: v.ymsBillId,
          ymsBillPackageDetailId: v.modifyInfo.ymsBillPackageDetailId
        };
      } else {
        url = api.post_ymsBillPackageDetail_insertRemarks;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000194');
        query = {
          remark: v.modifyInfoForm.remark,
          ymsBillId: v.ymsBillId,
          ymsBillPackageDetailId: v.modifyInfo.ymsBillPackageDetailId
        };
      }
      v.$refs['modifyInfoForm'].validate((valid) => {
        if (valid) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.modifyInfoModal = false;
              v.$Message.success(text);
              v.initLogisticsBillDetails();
            }
          });
        }
      });
    },
    // 切换订单
    checkChange() {
      this.getPhaseData();
      this.pageParamsStatus = true;
    },
    // 获取未对账和盈亏数据
    getPhaseData() {
      let v = this;
      let query = {
        types: v.pageParams.types,
        ymsBillId: v.ymsBillId,
      };
      v.unreconciledOrderQuantity = 0;
      v.payoffAmount = 0;
      v.axios.post(api.post_ymsBillPackageDetail_unreconciledAndProfitAndLoss, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.unreconciledOrderQuantity = data.unreconciledOrderQuantity || 0;
            v.payoffAmount = data.payoffAmount || 0;
          }
        }
      });
    },
    // 修改币种
    changeCurrency(val) {
      let v = this;
      if (val) {
        let query = {
          currency: val,
          ymsBillId: v.ymsBillId
        };
        v.axios.post(api.post_ymsBillPackageDetail_updateLogisticsBillCurrency, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003714'));
            v.getLogisticsBillDetailsData();
            v.getPhaseData();
            v.getLogisticsBillDetailsList();
          }
        });
      }
    },

    // 监听弹窗
    modifyInfoChange(value) {
      if (!value) {
        this.$refs['modifyInfoForm'].resetFields();
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getLogisticsBillDetailsList();
        v.pageParamsStatus = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.details_box_styles .options_content {
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
}
</style>
